import AccountDepositOverdraftSettings from "@/models/Accounts/DepositAccounts/Settings/AccountDepositOverdraftSettings";
import BaseUpdateAccountSettings from "@/models/Accounts/Shared/BaseUpdateAccountSettings";
import Amount from "@/models/Shared/Amount";

export default class UpdateAccountDepositOverdraftSettingsRequest extends BaseUpdateAccountSettings {
    enabled: boolean = false;
    hardLimit: Amount = new Amount();
    softLimit: Amount = new Amount();
    reviewDateUtc: Date;

    public constructor(settings?: AccountDepositOverdraftSettings, updatedAt?: Date, defaultWalletCurrency?: string) {
        super(updatedAt);
        if (settings) {
            const settingsCopy = JSON.parse(JSON.stringify(settings));
            this.enabled = settingsCopy.enabled;
            this.hardLimit = settingsCopy.hardLimit;
            this.hardLimit.currency = defaultWalletCurrency;
            this.softLimit = settingsCopy.softLimit;
            this.softLimit.currency = defaultWalletCurrency;
            this.reviewDateUtc = settingsCopy.reviewDateUtc;
        }
    }
}